import { TranslatedMessage, useCurrentWorkspace } from '@library/react-toolkit'
import { Menu } from 'antd'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { useSetMode } from './queries'

const ModeSelector = () => {
  const setMode = useSetMode()
  const ws = useCurrentWorkspace()
  const intl = useIntl()
  return (
    <Menu>
      <Menu.Item onClick={() => setMode('organization')}>
        {intl.formatMessage(
          { id: 'organizationInvoices' },
          {
            name: ws?.type === 'organization' ? ws.organization.name : '',
          }
        )}
      </Menu.Item>
      <Menu.Item onClick={() => setMode('supplier')}>
        <TranslatedMessage id="supplierInvoices" />
      </Menu.Item>
    </Menu>
  )
}

export default ModeSelector
